/** @jsx isolateComponent */
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '@zapier/design-system';

import { ServiceIconShell } from '../ServiceIconShell';

type ServiceIconNumericProps = {
  /*
   * Number to display within the icon box.
   */
  number: number;
};

const Styles = labelStyles('ServiceIconNumeric', {
  number: {
    ...Typography.bodyText900,
    color: Colors.blue500,
    fontWeight: 700,
    textIndent: -2, // Optical alignment
  },
});

export const ServiceIconNumeric = (props: ServiceIconNumericProps) => {
  const label = `Plus ${props.number} more apps.`;
  const width = props.number > 9 ? 45 : 40;
  return (
    <ServiceIconShell height={40} width={width}>
      <span aria-label={label} css={Styles.number}>
        <span aria-hidden="true">+{props.number}</span>
      </span>
    </ServiceIconShell>
  );
};
